// extracted by mini-css-extract-plugin
export var actionPlaceholder = "_ai-3";
export var contentContainer = "_ai-0";
export var editorContainer = "_ai-1";
export var quillInputForm = "_ai-2";
export var zoneDivider = "_ai-4";